export default __webpack_public_path__ + "static/media/restaurant-screenshot.a9ebd10c.png";